import { render, staticRenderFns } from "./downstreamPaymentDetail.vue?vue&type=template&id=77d09a51&scoped=true"
import script from "./downstreamPaymentDetail.vue?vue&type=script&lang=js"
export * from "./downstreamPaymentDetail.vue?vue&type=script&lang=js"
import style0 from "./downstreamPaymentDetail.vue?vue&type=style&index=0&id=77d09a51&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d09a51",
  null
  
)

export default component.exports